export const IS_DEVELOPMENT = ["localhost", "127.0.0.1"].includes(window.location.hostname);
export const IS_NOT_PRODUCTION = IS_DEVELOPMENT;
export const IS_PRODUCTION = !IS_DEVELOPMENT;
